import React from "react";
import { Box } from "@mui/material";

const CoreIcon = props => {
    const {size, imgSrc, sx} = props;
    
    return <Box 
        width={size}
        height={size}
        sx={{
            backgroundImage: `url(${imgSrc})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            ...sx
        }}
        
        >
    </Box>
}

CoreIcon.defaultProps = {
    size: "24px",
    imgSrc: ""
}

export default CoreIcon;